import { useCallback } from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";

import { Icon } from "@/components/Icon";
import { UpdatePurchasingPriorityMutation } from "../job-tracking/queries/tracking-data/useUpdatePurchasingPriorityMutation";
import { EffectivePriority } from "./purchasing-priority-utils";

export interface DeletePurchasingPriorityButtonProps {
  purchasingPriority: EffectivePriority;
  updatePurchasingPriorityMutation: UpdatePurchasingPriorityMutation;
  className: string;
}

/**
 * Component that renders a button to delete a purchasing priority override for a BOM node.
 */
export const DeletePurchasingPriorityButton: React.FC<DeletePurchasingPriorityButtonProps> = ({
  purchasingPriority,
  updatePurchasingPriorityMutation,
  className,
}) => {
  // Define a click handler for the delete button
  const handleDelete = useCallback(() => {
    // Do nothing if this node doesn't have a record to delete
    const recordToDelete = purchasingPriority.nodeJobRecord ?? purchasingPriority.nodeTemplateRecord;
    if (!recordToDelete) return;

    // Apply the mutation to delete the record
    updatePurchasingPriorityMutation.mutate({ action: "delete", recordsToDelete: [recordToDelete] });
  }, [purchasingPriority, updatePurchasingPriorityMutation]);

  return (
    <OverlayTrigger overlay={<Tooltip>Reset priority</Tooltip>}>
      <Button
        variant="link"
        size="sm"
        disabled={updatePurchasingPriorityMutation.isPending}
        onClick={handleDelete}
        className={className}
      >
        <Icon icon="arrow-counterclockwise" className="text-secondary" />
      </Button>
    </OverlayTrigger>
  );
};
